// extracted by mini-css-extract-plugin
module.exports = {"settingsContent":"SettingsPage_settingsContent__3T8y3","subHeaderActions":"SettingsPage_subHeaderActions__Yg7We"};